var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.IsInRoles([
        _vm.roles.GerenteDeSoporte,
        _vm.roles.SuperUsuario,
        _vm.roles.EncargadaCompras,
        _vm.roles.GerenteRRHH,
        _vm.roles.SupervisorDeTécnicos,
        _vm.roles.GerenciaGeneral,
        _vm.roles.CoordinadorIso,
        _vm.roles.DirectorDeProyectos,
        _vm.roles.CoordinadorDeSoporte,
        _vm.roles.DirectorAdministrativo,
        _vm.roles.CoornidadorDeServicioAlCliente,
        _vm.roles.EncargadoDesarrolloDeAplicaciones,

        _vm.roles.CEO,
        _vm.roles.SupervisorDeSoporteDeVentas,
        _vm.roles.SupervisorDeVentas
      ])
    )?_c('rabbey-toolbox',{attrs:{"call-new":_vm.callNew,"filterables":true}},[_c('el-select',{staticClass:"box-item",attrs:{"size":"mini","clearable":""},on:{"change":_vm.handleCompanyChange},model:{value:(_vm.companyId),callback:function ($$v) {_vm.companyId=$$v},expression:"companyId"}},_vm._l((_vm.companyList),function(company){return _c('el-option',{key:company.value,attrs:{"label":company.label,"value":company.value}})}),1)],1):_vm._e(),_c('el-row',[_c('el-col',[_c('rabbey-table3',{ref:"LegalTable",attrs:{"loading":_vm.loading,"data":_vm.items,"actions":_vm.actions,"columns":_vm.columns},on:{"rtable-push-action":_vm.actionHandler}})],1)],1),_c('el-drawer',{attrs:{"title":this.selectedRowDocumentName
        ? 'Actualizar Documento: ' + this.selectedRowDocumentName
        : 'Nuevo Documento',"visible":_vm.legal_visible,"size":"20%"},on:{"update:visible":function($event){_vm.legal_visible=$event}}},[_c('div',{staticClass:"flex gaps column demo-drawer__content border-myborder",staticStyle:{"padding":"20px"}},[_c('div',{attrs:{"id":"div-legal"}},[_c('NewLegal',{staticClass:"scrollable",staticStyle:{"max-height":"800px"},attrs:{"RowDocumentId":_vm.selectedRowId,"RowDocumentDueDate":_vm.selectedRowDueDate},on:{"dialog-closed":_vm.handleDialogClose,"getData":_vm.getTableData}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }